import {
  Box,
  Divider,
  IconButton,
  makeStyles,
  Paper,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { grey, orange } from '@material-ui/core/colors';
import InfoIcon from '@material-ui/icons/Info';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import clsx from 'clsx';
import React from 'react';
import { useThemeType } from '../../contexts/ThemeTypeContext';
import { mainishStyles } from '../../styling';

const useStyles = makeStyles((theme) => ({
  footerParent: {
    bottom: 0,
    zIndex: -100,
  },
  footerPaper: {
    backgroundColor: '#181A1C',
    color: '#e0e0e0',
    minHeight: 125,
    bottom: 0,
    padding: theme.spacing(2),

    alignContent: 'center',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  footerBoxOuter: {
    display: 'flex',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: { flexDirection: 'column' },
    [theme.breakpoints.up('sm')]: { flexDirection: 'row' },
  },
  infobox: {
    flexDirection: 'column',
    display: 'flex',
    margin: theme.spacing(2),
  },
  infoTyp: {
    align: 'left',
  },
  img: {
    width: '100%',
    height: 0,
    boxShadow: '0rem 1.5rem 1rem 0.5rem #0000002E',
  },
  logoItb: {
    width: 72,
    height: 'auto',
  },
  logobox: {
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2),
    minWidth: 230,
    '&:hover': {
      cursor: 'pointer',
    },
  },

  STEIITBBox: {
    display: 'inline',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  STEIITBTypography: {
    marginLeft: 8,
    fontWeight: 'bolder',
    letterSpacing: 2,
    fontSize: 32,
  },

  dividerVertical: {
    width: 3,
    backgroundColor: grey[700],
  },
  dividerHorizontal: {
    height: 3,
    backgroundColor: grey[700],
  },
  footerBottomPaper: {
    backgroundColor: '#141517',
    color: '#e0e0e0',
    minHeight: 64,
    bottom: 0,
    padding: theme.spacing(2),

    alignContent: 'center',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  footerBottomBoxOuter: {
    width: '100%',
    display: 'flex',
    [theme.breakpoints.down('sm')]: { flexDirection: 'column' },
    [theme.breakpoints.up('sm')]: { flexDirection: 'row' },
  },
  footerBottomBoxLeft: {
    display: 'flex',
    marginRight: 'auto',
    marginLeft: 0,
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footerBottomBoxRight: {
    display: 'flex',
    marginRight: 0,
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: { marginRight: 'auto' },
  },
  bottomIconButtons: {
    color: orange[500],

    '&:hover': {
      color: orange[300],
    },
  },
}));

function Footer() {
  const classes = useStyles();
  const mainishClasses = mainishStyles();
  const themeHelper = useThemeType();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <div className={classes.footerParent}>
      <Paper
        elevation={6}
        square
        className={clsx(classes.footerPaper, mainishClasses.footer, {
          [mainishClasses.footerShift]: themeHelper.drawerState,
        })}
      >
        <Box className={classes.footerBoxOuter}>
          <Box
            className={classes.logobox}
            onClick={() => {
              window.open('https://stei.itb.ac.id/', '_blank');
            }}
          >
            <img src="/res/logo_itb_256.png" className={classes.logoItb}></img>
            <Typography className={classes.STEIITBTypography}>
              STEI-ITB
            </Typography>
          </Box>
          <Divider
            className={
              matches ? classes.dividerVertical : classes.dividerHorizontal
            }
            orientation={matches ? 'vertical' : 'horizontal'}
            flexItem
          />
          <Box className={classes.infobox}>
            <Typography className={classes.infoTyp}>
              Jalan Ganesha 10, Labtek VIII Lantai 2,
            </Typography>
            <Typography className={classes.infoTyp}>
              Bandung, Jawa Barat 40132
            </Typography>
            <Typography className={classes.infoTyp}>Indonesia</Typography>

            <Typography className={classes.infoTyp}>
              Phone : +62-22-2502260
            </Typography>
            <Typography className={classes.infoTyp}>
              Sekretariat: +62 821-2065-3837
            </Typography>
            <Typography className={classes.infoTyp}>
              info@stei.itb.ac.id
            </Typography>
          </Box>
          <Divider
            className={
              matches ? classes.dividerVertical : classes.dividerHorizontal
            }
            orientation={matches ? 'vertical' : 'horizontal'}
            flexItem
          />
          <Box className={classes.infobox}>
            <Typography
              className={classes.infoTyp}
              variant="h5"
              style={{ fontWeight: 'bold' }}
            >
              Layanan Administrasi Akademik
            </Typography>
            <Divider
              orientation="horizontal"
              style={{
                height: 3,
                backgroundColor: theme.palette.secondary.main,
              }}
              flexItem
            />
            <Typography className={classes.infoTyp}>
              Phone : +62-22-2508135
            </Typography>
            <Typography className={classes.infoTyp}>
              Sekre Akademik : +62-812-1280-4686
            </Typography>
            <Typography className={classes.infoTyp}>
              akademik@stei.itb.ac.id
            </Typography>
          </Box>
        </Box>
      </Paper>
      <Paper
        elevation={8}
        square
        className={clsx(classes.footerBottomPaper, mainishClasses.footer, {
          [mainishClasses.footerShift]: themeHelper.drawerState,
        })}
      >
        <Box className={classes.footerBottomBoxOuter}>
          <Box className={classes.footerBottomBoxLeft}>
            <Typography align={matches ? 'left' : 'center'}>
              Sekolah Teknik Elektro dan Informatika. All rights reserved 2021
            </Typography>
          </Box>
          <Box className={classes.footerBottomBoxRight}>
            <Tooltip arrow title="LinkedIn STEI ITB">
              <IconButton
                color="secondary"
                onClick={() => {
                  window.open(
                    'https://www.linkedin.com/company/14703345',
                    '_blank'
                  );
                }}
              >
                <LinkedInIcon />
              </IconButton>
            </Tooltip>
            <Tooltip arrow title="Instagram STEI ITB">
              <IconButton
                color="secondary"
                onClick={() => {
                  window.open('https://instagram.com/stei.itb', '_blank');
                }}
              >
                <InstagramIcon />
              </IconButton>
            </Tooltip>
            <Tooltip arrow title="SOP Layanan Akademik STEI ITB">
              <IconButton
                color="secondary"
                onClick={() => {
                  window.open('https://stei.itb.ac.id/id/iso/', '_blank');
                }}
              >
                <InfoIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
    </div>
  );
}

export default Footer;
